export default "../src/img/favicon.ico";